module.exports = __webpack_public_path__ + "img/3.62bda06a.png";